import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { DECORATION_ASK } from '@constant'
import Rowbox from '../Common/Rowbox'
import Header from '../Common/Header'
import Item from './Item'
import Arrow from '../Common/Arrow'
@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getQaList()
  }

  render() {
    const { qa, themeConfig } = this.props.store
    const { list = [], total_count } = qa
    const color = themeConfig['text']

    return (
      <Rowbox
        type={DECORATION_ASK}
        store={this.props.store}
        style={{ height: 'auto', flexDirection: 'column' }}
        vCenter={false}
      >
        <Header title={`问大家（${total_count}）`} content={<Arrow />} />

        {list.length > 0 ? (
          list.slice(0, 2).map(item => {
            return <Item key={item.id} {...item} />
          })
        ) : (
          <div style={{ height: 98, paddingTop: 20, textAlign: 'center' }}>
            <div>服务好不好，问问体验过的人</div>
            <div
              style={{
                width: '100px',
                color,
                border: `1px solid ${color}`,
                padding: '5px',
                textAlign: 'center',
                marginTop: 10,
                display: 'inline-block',
                borderRadius: 49
              }}
            >
              去提问
            </div>
          </div>
        )}
      </Rowbox>
    )
  }
}
